import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DeviceTypes } from 'src/models/DeviceTypes';

export interface ScreenDimensions {
  width: number;
  height: number;
}

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectorService {
  private readonly currentDeviceType: BehaviorSubject<DeviceTypes> = new BehaviorSubject<DeviceTypes>(DeviceTypes.DESKTOP);
  private readonly currentDeviceScreenDimensions: BehaviorSubject<ScreenDimensions>
                                              = new BehaviorSubject<ScreenDimensions>({width: 0, height: 0});

  get deviceType(): DeviceTypes {
    return this.currentDeviceType.value;
  }
  set deviceType(value: DeviceTypes) {
    this.currentDeviceType.next(value);
  }

  get deviceScreenDimensions(): ScreenDimensions {
    return this.currentDeviceScreenDimensions.value;
  }
  set deviceScreenDimensions(value: ScreenDimensions) {
    this.currentDeviceScreenDimensions.next(value);
  }

  get deviceType$(): Observable<DeviceTypes> {
    return this.currentDeviceType.asObservable();
  }

  get deviceScreenDimensions$(): Observable<ScreenDimensions> {
    return this.currentDeviceScreenDimensions.asObservable();
  }

  constructor() {
  }
}
